import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ApplyPage = lazy(() => import('../pages/apply/page'));
const SellInquiryPage = lazy(() => import('../pages/sell-inquiry/page'));
const BuyInquiryPage = lazy(() => import('../pages/buy-inquiry/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/apply',
    element: <ApplyPage />,
  },
  {
    path: '/sell-inquiry',
    element: <SellInquiryPage />,
  },
  {
    path: '/buy-inquiry',
    element: <BuyInquiryPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;